import { useEffect, useState } from 'react';
import Header from '@/component/Header';
import { FactoryListTableColumns, UserDashboardStakeListTableColumns } from '@/component/pools/table/ColumnsData';
import { Tables } from '@/component/pools/table/Tables';
import { ShortenAddr } from '@/lib/Shorten';
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { readUserDashboardList } from '@/api/asset/factory/read';
import { ReadAdminDashboardType, ReadAdminDashboardUnstakeType, ResUserDashboardType } from '@/types';
import { GridColDef } from '@mui/x-data-grid';
import { now } from '@/lib/dayjs';
import StakeList from '@/component/user-dashboard/StakeList';
import UnStakeList from '@/component/user-dashboard/UnstakeList';
import RewardList from '@/component/user-dashboard/RewardList';
import WithdrawList from '@/component/user-dashboard/WithdrawList';

import { z as zod } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DatePickers from '@/component/date-pickers';
import Grid from '@mui/material/Unstable_Grid2';

const statusList = [
  { label: 'stake', value: '0' },
  { label: 'unstake', value: '1' },
  { label: 'withdraw', value: '2' },
  { label: 'reward', value: '3' },
];

const schema = zod.object({
  address: zod.string().optional(),
  title: zod.string().optional(),
  stakeState: zod.string().optional(),
});

type Values = zod.infer<typeof schema>;

const defaultValues = { address: '', title: '', stakeState: '' } satisfies Values;

export default function UserDashboard() {
  const [list, setList] = useState<ResUserDashboardType | null>(null);
  const [date, setDate] = useState({
    startDt: '',
    endDt: '',
  });
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
    reset,
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  useEffect(() => {
    (async () => {
      const payload: ReadAdminDashboardType = {};
      // const re = await readUserDashboardList(payload);
      // console.log(re);
      // if (re.status !== 200) {
      //   return;
      // }
      // console.log(re.data);
      // setList(re.data);
    })();

    return () => {};
  }, []);

  const onSubmit = async (data: Values) => {
    console.log('ffffffffffffffff');
    console.log(data);
    console.log(date);
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== '' && value !== undefined && value !== null),
    );
    const filteredDate = Object.fromEntries(
      Object.entries(date).filter(([_, value]) => value !== '' && value !== undefined && value !== null),
    );
    const payload: ReadAdminDashboardType = {
      ...filteredData,
      ...filteredDate,
    };
    // stakeState가 없으면 삭제
    if (!data?.stakeState) {
      delete payload.stakeState; // stakeState가 없으면 삭제
    } else {
      payload.stakeState = Number(data.stakeState); // 값이 있을 경우 추가
    }

    console.log(payload);
    const re = await readUserDashboardList(payload);
    console.log(re);
    if (re.status !== 200) {
      return;
    }
    console.log(re.data);
    setList(re.data);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header title="사용자 대시보드" />
        <Divider />
        <CardContent
          sx={{
            flex: 1, // CardContent가 나머지 공간을 차지하도록 설정
            overflow: 'auto', // 스크롤을 가능하게 함
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
              <Controller
                control={control}
                name="address"
                render={({ field }) => (
                  <FormControl error={Boolean(errors.address)}>
                    <InputLabel>address</InputLabel>
                    <OutlinedInput {...field} label="address" type="text" />
                    {errors.address ? <FormHelperText>{errors.address.message}</FormHelperText> : null}
                  </FormControl>
                )}
              />
              <Controller
                control={control}
                name="title"
                render={({ field }) => (
                  <FormControl error={Boolean(errors.title)}>
                    <InputLabel>title</InputLabel>
                    <OutlinedInput {...field} label="title" type="text" />
                    {errors.title ? <FormHelperText>{errors.title.message}</FormHelperText> : null}
                  </FormControl>
                )}
              />
              <Controller
                name="stakeState"
                control={control}
                render={({ field }) => (
                  <FormControl error={Boolean(errors.stakeState)}>
                    <InputLabel shrink htmlFor="select-multiple-native">
                      Status
                    </InputLabel>
                    <Select
                      labelId="stakeState"
                      label="stakeState"
                      {...field}
                      value={field.value || ''} // value 연동
                      onChange={(e: SelectChangeEvent) => {
                        console.log(e.target.value); // 선택 값 콘솔 출력
                        field.onChange(e.target.value); // 값 변경 처리
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>None</em>
                      </MenuItem>
                      {statusList &&
                        statusList.map((option) => (
                          <MenuItem key={option.label} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.stakeState && <FormHelperText>{errors.stakeState.message}</FormHelperText>}
                  </FormControl>
                )}
              />

              <Grid xs={12} sm={6}>
                <DatePickers label="시작일" setValue={setDate} poolName="startDt" defaultValue={date.startDt} />
              </Grid>
              <Grid xs={12} sm={6}>
                <DatePickers label="모금 종료일" setValue={setDate} poolName="endDt" defaultValue={date.endDt} />
              </Grid>

              <Button type="submit" variant="contained">
                검색
              </Button>

              <Button
                type="button"
                variant="contained"
                onClick={() => {
                  reset();
                  setDate({ startDt: '', endDt: '' });
                }}
              >
                초기화
              </Button>
            </Stack>
          </form>
          <StakeList list={list?.stake} />
          <Box mb={5} />
          <UnStakeList list={list?.unstake} />
          <Box mb={5} />
          <RewardList list={list?.reward} />
          <Box mb={5} />
          <WithdrawList list={list?.withdraw} />
        </CardContent>
      </Card>
    </Box>
  );
}
